/*============================================================================
  Shared shipping tables + helpers (window.BiriaShipping)
  ----------------------------------------------------------------------------
  Single source of truth for the weight-banded shipping profiles. Used by the
  PDP estimate (assets/pdp-shipping-estimate.js) and the cart total
  (assets/cart-shipping.js). Keep bands in sync with Settings > Shipping.

  Weights are lb, prices USD. Charge for a profile is set by the combined
  weight of the cart's items in that profile.
==============================================================================*/
window.BiriaShipping = window.BiriaShipping || (function () {
  var LB_PER_GRAM = 1 / 453.59237;

  // Each band: ship at this price when profile weight is <= max (lb), ascending.
  var PROFILES = {
    electric: [
      { max: 64, price: 130 },
      { max: 100.1, price: 180 },
      { max: 150.1, price: 359.99 },
      { max: 200.1, price: 479.99 },
      { max: 250.1, price: 599.99 }
    ],
    bike: [
      { max: 30.1, price: 90 },
      { max: 60.1, price: 160 },
      { max: 90.1, price: 210 },
      { max: 120.1, price: 279.99 },
      { max: 150.1, price: 349.99 }
    ],
    accessory: [
      { max: 5, price: 20 },
      { max: 10, price: 25 },
      { max: Infinity, price: 30 }
    ]
  };

  // Map a Shopify product type to its delivery profile. "electric" is checked
  // first because an "Electric Bike" type also contains "bike".
  function profileForType(type) {
    var t = (type || '').toLowerCase();
    if (t.indexOf('electric') > -1) return 'electric';
    if (t.indexOf('bicycle') > -1 || t.indexOf('bike') > -1) return 'bike';
    return 'accessory';
  }

  // Shipping charge for a profile at a total weight (lb). 0 when empty.
  function rate(profile, lb) {
    if (lb <= 0) return 0;
    var bands = PROFILES[profile];
    if (!bands) return 0;
    for (var i = 0; i < bands.length; i++) {
      if (lb <= bands[i].max) return bands[i].price;
    }
    return bands[bands.length - 1].price; // over the top band: cap at highest
  }

  // Total shipping for a set of cart.js line items: sum each profile's band.
  function cartTotal(items) {
    var gramsByProfile = {};
    (items || []).forEach(function (it) {
      var p = profileForType(it.product_type);
      gramsByProfile[p] = (gramsByProfile[p] || 0) + (it.grams || 0) * (it.quantity || 1);
    });
    var total = 0;
    Object.keys(gramsByProfile).forEach(function (p) {
      total += rate(p, gramsByProfile[p] * LB_PER_GRAM);
    });
    return total;
  }

  return {
    LB_PER_GRAM: LB_PER_GRAM,
    PROFILES: PROFILES,
    profileForType: profileForType,
    rate: rate,
    cartTotal: cartTotal
  };
})();
